/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Banner_Title_FreeInputs */

const en_try_banner_title_free = /** @type {(inputs: Try_Banner_Title_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try listening free`)
};

const es_try_banner_title_free = /** @type {(inputs: Try_Banner_Title_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba Listening gratis`)
};

/**
* | output |
* | --- |
* | "Try listening free" |
*
* @param {Try_Banner_Title_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_banner_title_free = /** @type {((inputs?: Try_Banner_Title_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Banner_Title_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_banner_title_free(inputs)
	return en_try_banner_title_free(inputs)
});